import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import Cookies from 'quasar/src/plugins/Cookies.js';import Loading from 'quasar/src/plugins/Loading.js';;
/**
 * Attempt to login.
 *
 * @param dispatch
 * @param data
 * @returns {*}
 */
export function login(_x, _x2) {
  return _login.apply(this, arguments);
}
function _login() {
  _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, data) {
    var dispatch, commit, _yield$dispatch, twoFactorEnabled;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dispatch = _ref.dispatch, commit = _ref.commit;
          _context.prev = 1;
          _context.next = 4;
          return dispatch('getCookie', data);
        case 4:
          _context.next = 6;
          return dispatch('api', {
            url: 'login',
            data: data,
            method: 'post',
            wait: 'auth-login',
            excludeApiPrefix: true
          }, {
            root: true
          });
        case 6:
          _yield$dispatch = _context.sent;
          twoFactorEnabled = _yield$dispatch.data.two_factor;
          return _context.abrupt("return", twoFactorEnabled);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 11]]);
  }));
  return _login.apply(this, arguments);
}
export function confirmPassword(_x3, _x4) {
  return _confirmPassword.apply(this, arguments);
}
function _confirmPassword() {
  _confirmPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, password) {
    var dispatch;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dispatch = _ref2.dispatch;
          _context2.next = 3;
          return dispatch('api', {
            url: 'user/confirm-password',
            method: 'post',
            excludeApiPrefix: true,
            data: {
              password: password
            }
          }, {
            root: true
          });
        case 3:
          dispatch('enableMFA');
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _confirmPassword.apply(this, arguments);
}
export function enableMFA(_x5) {
  return _enableMFA.apply(this, arguments);
}
function _enableMFA() {
  _enableMFA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var dispatch;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          dispatch = _ref3.dispatch;
          _context3.next = 3;
          return dispatch('api', {
            method: 'post',
            url: 'user/two-factor-authentication',
            excludeApiPrefix: true
          }, {
            root: true
          });
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _enableMFA.apply(this, arguments);
}
export function getQRCode(_x6) {
  return _getQRCode.apply(this, arguments);
}
function _getQRCode() {
  _getQRCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4) {
    var dispatch, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dispatch = _ref4.dispatch;
          _context4.next = 3;
          return dispatch('api', {
            url: 'user/two-factor-qr-code',
            excludeApiPrefix: true
          }, {
            root: true
          });
        case 3:
          response = _context4.sent;
          return _context4.abrupt("return", response);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getQRCode.apply(this, arguments);
}
export function authenticateUser(_x7) {
  return _authenticateUser.apply(this, arguments);
}
function _authenticateUser() {
  _authenticateUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5) {
    var dispatch, commit, getters, _yield$dispatch2, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          dispatch = _ref5.dispatch, commit = _ref5.commit, getters = _ref5.getters;
          if (!getters['auth/isLoggedIn']) {
            _context5.next = 3;
            break;
          }
          return _context5.abrupt("return", true);
        case 3:
          _context5.prev = 3;
          _context5.next = 6;
          return dispatch('api', {
            url: 'auth/user'
          }, {
            root: true
          });
        case 6:
          _yield$dispatch2 = _context5.sent;
          data = _yield$dispatch2.data.data;
          commit('SET_USER', data);
          return _context5.abrupt("return", true);
        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](3);
          return _context5.abrupt("return", false);
        case 15:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[3, 12]]);
  }));
  return _authenticateUser.apply(this, arguments);
}
export function getCookie(_x8, _x9) {
  return _getCookie.apply(this, arguments);
}
/**
 * Logout user. Remove auth cookie, browser redirect to the login page.
 *
 * @param dispatch
 * @returns {Promise<void>}
 */
function _getCookie() {
  _getCookie = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref6, data) {
    var dispatch;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          dispatch = _ref6.dispatch;
          dispatch('api', {
            url: 'sanctum/csrf-cookie',
            excludeApiPrefix: true,
            method: 'get',
            data: data
          }, {
            root: true
          });
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getCookie.apply(this, arguments);
}
export function getRecoveryCodes(_x10) {
  return _getRecoveryCodes.apply(this, arguments);
}
function _getRecoveryCodes() {
  _getRecoveryCodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref7) {
    var dispatch, data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          dispatch = _ref7.dispatch;
          _context7.next = 3;
          return dispatch('api', {
            url: 'user/two-factor-recovery-codes',
            excludeApiPrefix: true
          }, {
            root: true
          });
        case 3:
          data = _context7.sent;
          return _context7.abrupt("return", data);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getRecoveryCodes.apply(this, arguments);
}
export function logout(_x11) {
  return _logout.apply(this, arguments);
}
function _logout() {
  _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref8) {
    var dispatch,
      showLoading,
      _args8 = arguments;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          dispatch = _ref8.dispatch;
          showLoading = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : true;
          showLoading && Loading.show({
            message: 'Logging out... Good bye!'
          });
          _context8.next = 5;
          return dispatch('api', {
            method: 'post',
            url: '/logout',
            excludeApiPrefix: true,
            commitAfter: 'auth/CLEAR'
          }, {
            root: true
          });
        case 5:
          // TODO resolve cookie deletion
          Cookies.remove('XSRF-TOKEN', {
            domain: '.carecommons.test',
            path: '/'
          });
          window.location.href = '/login';
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _logout.apply(this, arguments);
}